import { styled } from '@mui/material/styles';

export const SceneIcon = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '.MuiSvgIcon-root': {
    display: 'block',
    fontSize: '4rem',
  },
}));
